<div class="split-pdf-modal">
  <h1 mat-dialog-title>
    Split PDF
    <mat-icon class="close-icon condenced" alt="Close dialog" (click)="close()"> close </mat-icon>
  </h1>
  <div mat-dialog-content>
    <div class="split-pdf-pages">
      <ng-container *ngFor="let page of pages; let i = index;">
        <div class="pdf-page-wrapper">
          <pdf-viewer
            [src]="page.data"
            [render-text]="false"
            [original-size]="false"
            [autoresize]="true"
            [zoom-scale]="'page-width'"
            style="width: 300px; height: 400px;"
          ></pdf-viewer>
        </div>
        <div *ngIf="i + 1 < pages.length" class="split-section">
          <p class="split-desc">
            {{ page.split ? 'Splitting' : 'Click to Split' }}
          </p>
          <button 
            mat-icon-button
            [attr.aria-label]="'Split the PDF between pages ' + (i+1) + ' and ' + (i+2)"
            (click)="toggleSplit(page)"
          >
            <mat-icon>content_cut</mat-icon>
          </button>
          <div class="divider" [class.split]="page.split"></div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="confirm-actions" mat-dialog-actions>
      <button mat-button class="secondary" (click)="splitAll()">Split All</button>
      <button mat-button class="primary" (click)="confirmSplit()">
          Confirm Split
      </button>
  </div>
</div>
